import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "toolbar", "count"]

  toggle() {
    this.updateToolbar()
  }

  toggleAll() {
    if (!this.hasSelectAllTarget) return
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateToolbar()
  }

  updateToolbar() {
    const selected = this.checkboxTargets.filter(cb => cb.checked).length
    if (this.hasToolbarTarget) {
      if (selected > 0) {
        this.toolbarTarget.classList.add("active")
        if (this.hasCountTarget) this.countTarget.textContent = `${selected} selected`
      } else {
        this.toolbarTarget.classList.remove("active")
      }
    }
  }
}
